import { NgModule } from '@angular/core';
import { UserMessagesRoutingModule } from './user-messages-routing.module';
import { UserMessagePageComponent } from './features/user-message-page/user-message-page.component';
import { UserMessagesPageComponent } from './features/user-messages-page/user-messages-page.component';
import { UiModule } from '../../../lib/ui/ui.module';

@NgModule({
  imports: [
    UiModule,
    UserMessagesRoutingModule,
  ],
  declarations: [
    UserMessagePageComponent,
    UserMessagesPageComponent,
  ],
  exports: [
    UserMessagesPageComponent,
  ]
})
export class UserMessagesModule {}
